import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

interface CookieConsentProps {
  onAccept: (analytics: boolean) => void;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept }) => {
  const { t, language } = useLanguage();
  const [show, setShow] = useState(false);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(true);

  useEffect(() => {
    // Check if consent was already given
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(
      'cookie_consent',
      JSON.stringify({
        analytics: analyticsEnabled,
        timestamp: new Date().toISOString(),
      })
    );
    setShow(false);
    onAccept(analyticsEnabled);
  };

  const handleReject = () => {
    localStorage.setItem(
      'cookie_consent',
      JSON.stringify({
        analytics: false,
        timestamp: new Date().toISOString(),
      })
    );
    setShow(false);
    onAccept(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-gray-200 dark:border-gray-800 shadow-2xl p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-headings mb-2">
              {language === 'tr' ? 'Çerez Kullanımı' : 'Cookie Usage'}
            </h3>
            <p className="text-sm text-main mb-3">
              {language === 'tr' 
                ? 'Web sitemizde size en iyi deneyimi sunabilmek için çerezler kullanıyoruz. Analitik çerezler, site kullanımınızı anlamamıza ve iyileştirmeler yapmamıza yardımcı olur.'
                : 'We use cookies to provide you with the best experience on our website. Analytics cookies help us understand your site usage and make improvements.'}
            </p>
            <label className="flex items-center space-x-2 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
              <input
                type="checkbox"
                checked={analyticsEnabled}
                onChange={(e) => setAnalyticsEnabled(e.target.checked)}
                className="w-4 h-4 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-700 rounded focus:ring-gray-900 dark:focus:ring-gray-100"
              />
              <span>
                {language === 'tr' 
                  ? 'Analitik çerezleri kabul et (önerilir)'
                  : 'Accept analytics cookies (recommended)'}
              </span>
            </label>
          </div>
          <div className="flex gap-3 flex-shrink-0">
            <button
              onClick={handleReject}
              className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg transition-colors"
            >
              {language === 'tr' ? 'Reddet' : 'Reject'}
            </button>
            <button
              onClick={handleAccept}
              className="px-4 py-2 text-sm font-medium text-white bg-gray-900 dark:bg-white dark:text-gray-900 hover:bg-gray-800 dark:hover:bg-gray-100 rounded-lg transition-colors"
            >
              {language === 'tr' ? 'Kabul Et' : 'Accept'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;








